
import { FormControlLabel, Grid, Typography, styled } from '@mui/material';
import { FC, ReactElement } from 'react';

import { IFormField, IFormFieldRow, IFormFieldTitle, TitlePosition } from '../../../../api/dtos/dtos';
import MuiMarkdown from 'mui-markdown';

/* -- Styled Components -- */
const StyledCheckboxControlLabel = styled(FormControlLabel)(() => ({
    margin: '0',
    padding: '0',

    '&.MuiFormControlLabel-labelPlacementEnd.radio-control-label span': {
        width: 'auto',
    }
}));

export interface ICheckboxControlLabelProps {
    field: IFormField & IFormFieldTitle & IFormFieldRow;
    control: ReactElement<any, any>
}

const CheckboxControlLabel: FC<ICheckboxControlLabelProps> = ({
    field,
    control
}) => {
    return (
        <Grid 
            item
            xs={field.rowRatio ?? 12}
        >
            {
                field.titlePos === TitlePosition.Left || 
                field.titlePos === TitlePosition.Right || 
                field.titlePos === TitlePosition.Top ? 
                    <StyledCheckboxControlLabel
                        className='radio-control-label'
                        labelPlacement={
                            field.titlePos === TitlePosition.Left ? 'start' : 
                            field.titlePos === TitlePosition.Right ? 'end' :
                            'top'
                        }
                        label={
                            <Typography 
                                sx={{ 
                                    margin: '0', 
                                    // width: field.titleWidth ? `${field.titleWidth}px` : 'auto',
                                    width: '100%',
                                    textAlign: field.titlePos === TitlePosition.Right ? 'start' : 'end',
                                    marginRight: !field.titleWidth && field.titlePos === TitlePosition.Left ? '5px' : '0px',
                                    marginLeft: !field.titleWidth && field.titlePos === TitlePosition.Right ? '5px' : '0px'
                                }}
                            >
                                <MuiMarkdown>
                                    {field.title}
                                </MuiMarkdown>
                            </Typography>
                        } 
                        control={control} 
                    /> :
                field.titlePos === TitlePosition.TopLeft || 
                field.titlePos === TitlePosition.TopRight || 
                field.titlePos === undefined ?
                    <StyledCheckboxControlLabel
                        labelPlacement='top'
                        label={
                            <Typography 
                                sx={{ 
                                    margin: '0',
                                    textAlign: field.titlePos === TitlePosition.TopRight ? 'end' : 'start',
                                }}
                            >
                                <MuiMarkdown>
                                    {field.title}
                                </MuiMarkdown>
                            </Typography>
                        } 
                        control={control} 
                    /> : 

                    control
            }
        </Grid>
    );
}

export default CheckboxControlLabel